import logo from './logo.svg';
import './App.css';
import NavComp from './Components/NavComp';
import { Container } from 'react-bootstrap';
import Statistics from './Components/Statistics';
import Footer from './Components/Footer';
import Banner from './Components/Banner';
import SerivceSection from './Components/SerivceSection';
import ContactUs from './Components/ContactUs';

function App() {
  return (
    <div className="App">
      <Container>
      <NavComp/>
      </Container>
      <Banner/>
      <Statistics/>
      <SerivceSection/>
      <ContactUs/>
      <Footer/>
    </div>
  );
}

export default App;
